(function (angular) {
    angular.module('bizPartEngage').filter('hoursto', function () {
        return function (time, isutc) {
            if (time) {
                var from = moment();
                if (isutc) {
                    var date = new Date();
                    from = from.add(date.getTimezoneOffset(), 'minutes');
                }
                var to = moment(time);
                var duration = moment.duration(to.diff(from));
                return Math.floor(duration.asHours()) + 'H ' + duration.minutes() + 'M';
            }
        }
    });

    angular.module('bizPartEngage').filter('date', function () {
        return function (value, format) {
            if (value)
                return moment(value).format(format || 'L');
        }
    });

    angular.module('bizPartEngage').filter('time', function () {
        return function (value) {
            if (value)
                return moment(value).format('LT');
        }
    });

    angular.module('bizPartEngage').filter('timeSince', timeSince);

    timeSince.$inject = ["$translate"];

    function timeSince($translate) {
        return function(time) {
            var justNow = $translate.instant("CORE.JUST_NOW");
            return moment(time).fromNowOrNow(undefined, justNow.toString());
        }
    }

    angular.module('bizPartEngage').filter('datetime', function () {
        return function (value, isutc) {
            if (value) {
                if (isutc) {
                    var m = moment(value);
                    return m.subtract(m.utcOffset(), 'm').format('L LT');
                }
                return moment(value).format('L LT');
            }
        }
    });

    angular.module('bizPartEngage').filter('xptype', xptypeFilter);

    xptypeFilter.$inject = ["bizLevel"];

    function xptypeFilter(levelProvider) {
    	var cache = {};

        function xptypeFilterFunction(value) {
        	if (cache[value]) {
                return cache[value];
        	}
        	else {
        		cache[value] = "Loading translation...";
        		levelProvider.getExperienceTypeLabel(value).then(function (val) {
                    cache[value] = val;
        		}, function (err) {
        			console.log("Failed to find translation:" + err);
        			cache[value] = "Failed to load translation";
        		});
            }
        }
        xptypeFilterFunction.$stateful = true;

        return xptypeFilterFunction;
    }
})(window.angular);
